import React, { useState } from 'react';
import { RefundPolicyModal } from './RefundPolicyModal';
export function Footer() {
  const [isPolicyOpen, setIsPolicyOpen] = useState(false);
  return <>
      <footer className="bg-dark text-gray-400 py-12 px-4 text-center border-t border-gray-800" data-id="element-101">
        <div className="max-w-4xl mx-auto" data-id="element-102">
          <h3 className="font-serif text-2xl text-white mb-6 italic" data-id="element-103">
            Ciclo en Calma
          </h3>

          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 mb-8 text-sm" data-id="element-104">
            <a href="#" className="hover:text-white transition-colors" data-id="element-105">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-106">
              Política de Privacidad
            </a>
            <button type="button" onClick={() => setIsPolicyOpen(true)} className="hover:text-white transition-colors underline-offset-4 hover:underline" data-id="element-107">
              Política de Devolución
            </button>
            <a href="#" className="hover:text-white transition-colors" data-id="element-108">
              Contacto
            </a>
          </div>

          <p className="text-sm mb-4" data-id="element-109">
            Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>

          <p className="text-sm" data-id="element-110">
            © {new Date().getFullYear()} Ciclo en Calma · Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      <RefundPolicyModal isOpen={isPolicyOpen} onClose={() => setIsPolicyOpen(false)} data-id="element-111" />
    </>;
}